const Employer = {
  queryList: [
    {
      name: 'schoolName',
      label: '单位名称',
      component: 'input'
    },
    {
      name: 'name',
      label: '联系人',
      component: 'input'
    },
    {
      name: 'mobile',
      label: '联系电话',
      component: 'input'
    }
  ],
  urlMap: {
    select: '/school/schoolDegreeOffice/list',
    update: '/school/schoolDegreeOffice/saveOrUpdate',
    delete: '/school/schoolDegreeOffice/delete/{id}'
  },
  operList: [// 操作列表
    {
      name: 'add',
      label: '新增',
      show: true,
      action: {
        type: 'dialog',
        addr: 'systemManage/employerEdit2'
      }
    }
  ],
  titles: [
    {
      name: 'schoolName',
      label: '单位名称'
    },
    {
      name: 'department',
      label: '所属学院'
    },
    {
      name: 'name',
      label: '联系人'
    },
    {
      name: 'mobile',
      label: '联系电话'
    },
    {
      name: 'cardType',
      label: '证件类型'
    },
    {
      name: 'identityCard',
      label: '证件号码'
    }
    // ,
    // {
    //   name: 'operation',
    //   label: '操作',
    //   actionList: [
    //     {
    //       label: '修改',
    //       name: 'update',
    //       kind: 'primary', // error
    //       type: 'dialog', // request, router, dialog, func
    //       addr: 'systemManage/employerEdit2?{userId}'
    //     },
    //     {
    //       label: '删除',
    //       kind: 'primary',
    //       type: 'request',
    //       addr: '/school/schoolDegreeOffice/saveOrUpdate',
    //       data: {userId: '{userId}', status: '0'},
    //       confirm: {
    //         desc: '确认删除？'
    //       }
    //     }
    //   ]
    // }
  ]
}
export default Employer



// WEBPACK FOOTER //
// ./src/layout/regularPage/config/systemManage/employer2.js